<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="false" (onNavigateBackClick)="navigateBack()"></ya-subheader>
  <ng-container *ngIf="webVoucherLandingPage$|async let webVoucher_landingPage">
    <div *ngIf="webVoucher_landingPage.hasImage" class="aspect-ratio-box">
      <div class="webVoucher-image--top">
        <div class="aspect-ratio-box-inside">
          <div class="aspect-ration-img-box">
            <img class="ya_image image" [src]="webVoucher_landingPage.image " rel="preload" alt="Logo" />
          </div>
        </div>
      </div>
    </div>
    <div class="ya-page-content ya-page-content--webshop ya-page-content--inset">
      <div class="webVoucher-page__info" [class.webVoucher-page__noImage]="!webVoucher_landingPage.hasImage">
        <ng-container *ngIf="webVoucher_landingPage.label!==''">
          <h2>{{webVoucher_landingPage.label}}</h2>
        </ng-container>
        <ng-container *ngIf="webVoucher_landingPage.description!==''">
          <span>{{webVoucher_landingPage.description}}</span>
        </ng-container>
      </div>
      <div a11y_Button class="webVoucher-item-container">
        <ng-container *ngIf="webVouchers$ | async; let webVouchers">
          <ng-container *ngFor="let webVoucher of webVouchers">
            <div class="webVoucher-item" [class.item-animated]="isLoaded">
              <a (click)="navigateToWebVoucherDetail(webVoucher.id)">
                <div class="aspect-ratio-box webVoucher-item__img">
                  <div class="aspect-ratio-box-inside">
                    <div class="aspect-ration-img-box">
                      <img class="ya_image" [src]="webVoucher.hasImage? webVoucher.image:''" alt="" />
                    </div>
                  </div>
                </div>
                <div class="webVoucher-item__bar">
                  <div class="webVoucher-item__label">
                    <ng-container *ngIf="webVoucher.label!==''">
                      <h2>{{webVoucher.label}}</h2>
                    </ng-container>
                  </div>
                  <div class="webVoucher-item__info">
                    <ng-container *ngIf="displayPrice(webVoucher.price)">
                      <span>{{formatCurrency(webVoucher.price)}}</span>
                    </ng-container>
                    <div class="webVoucher-item__forwardicon">
                      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-keyboard_backspace"></div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="itemsInBasket > 0">
    <a @plopInOut routerLink="/webshop" class="warenkorb-btn" [matBadge]="itemsInBasket">
      <div class="text" langkey="phWebshop_View_Cart">
      </div>
      <div class="icon">
        <div id="header-icon-basket" class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
      </div>
    </a>
  </ng-container>
</div>